import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { loadBills } from '@/modules/bill/actions/async/load-bills';
import { loadUpcomingBill } from '@/modules/bill/actions/async/load-upcoming-bill';
import { getBills, getUpcomingBill } from '@/modules/bill/store/selectors';
import { getCityTimezone } from '@/modules/partner/store/selectors';
import { AppDispatch } from '@/root-store';

import { View } from './view';

const List = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  usePermissions('viewBills');

  useEffect(() => {
    dispatch(loadUpcomingBill());
  }, [dispatch]);

  const bills = useSelector(getBills);
  const upcomingBill = useSelector(getUpcomingBill);
  const timezone = useSelector(getCityTimezone);

  const fetchBills = useCallback<React.ComponentProps<typeof View>['fetchBills']>(
    (_, { limit, offset }) => {
      setIsLoading(true);
      dispatch(loadBills({ limit, offset }))
        .unwrap()
        .finally(() => {
          setIsLoading(false);
        });
    },
    [dispatch, setIsLoading],
  );

  return (
    <View
      upcomingBill={upcomingBill}
      bills={bills}
      fetchBills={fetchBills}
      timezone={timezone}
      isLoading={isLoading}
    />
  );
};

export { List };
